import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import Image from "gatsby-image/withIEPolyfill"
import browser from 'browser-detect'
import BackgroundImage from 'gatsby-background-image'
import { Link } from "@components/Link"
// import { Pc } from "@hooks/useMediaQuery"
// import { useStores } from "@hooks/useStores"
import { useURL } from "@hooks/useURL"
// import { useGtm } from "@hooks/useGtm"

import css from "@css/components/blocks/IndexSct06.module.styl"


export default function IndexHero()
{
    // const gtm = useGtm()
    // const handler = (label) => {
    //     gtm.push(['FireEvent','arrows5G Adobe','click', label])
    // }
    const q = useStaticQuery(graphql`
        query {
            title: file(relativePath: { eq: "Hero__img__title.svg" }) {
                publicURL
            }
            device01: file(relativePath: { eq: "Sct06__img__device-01@2x.png" }) {
                childImageSharp {
                    fluid(maxWidth: 286) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            device02: file(relativePath: { eq: "Sct06__img__device-02@2x.png" }) {
                childImageSharp {
                    fluid(maxWidth: 286) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            bg: file(relativePath: { eq: "Sct06__img__bg@2x.jpg" }) {
                childImageSharp {
                    fluid(maxWidth: 1440) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            icon: file(relativePath: { eq: "Sct06__img__appicon@2x.png" }) {
                childImageSharp {
                    fluid(maxWidth: 180) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            logo: file(relativePath: { eq: "Sct06__img__applogo.svg" }) {
                publicURL
            }

            googleplay: file(relativePath: { eq: "Sct06__btn__googleplay@2x.png" }) {
                childImageSharp {
                    fluid(maxWidth: 268) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
        }
    `)

    const urls = useURL()
    return pug`
        div(className=${css.container})
            // BackgroundImage(fluid=${q.bg.childImageSharp.fluid})
            div(className=${css.inner})
                div(className=${css.app})
                    div(className=${css.icon})
                        Image(fluid=${q.icon.childImageSharp.fluid})
                    h1(className=${css.logo})
                        img(src=${q.logo.publicURL} alt="Adobe Photoshop Express")
                    p(className=${css.text})
                        |フィルター、文字入れ、切り取り等ができるフォトエディタ
                    div(className=${css.buttons})
                        a(className=${css.item} href=${urls.googleplay} onClick=${()=>{
                            if( typeof window._gaq !== "undefined"){
                                window._gaq.push(['_trackEvent','arrows5G F-51A_adobeLPページ','click', 'Playストア_F-51A_adobeLPページ'])
                            }
                        }})
                            Image(fluid=${q.googleplay.childImageSharp.fluid})        
                div(className=${css.devices})
                    div(className=${css.devices_inner})
                        div(className=${css.device01})
                            Image(fluid=${q.device01.childImageSharp.fluid})
                        div(className=${css.device02})
                            Image(fluid=${q.device02.childImageSharp.fluid})



`
}
